import { render } from "./CustomizeSelectAdsetAdsDialog.vue?vue&type=template&id=013a5f9c"
import script from "./CustomizeSelectAdsetAdsDialog.vue?vue&type=script&lang=js"
export * from "./CustomizeSelectAdsetAdsDialog.vue?vue&type=script&lang=js"

import "./CustomizeSelectAdsetAdsDialog.vue?vue&type=style&index=0&id=013a5f9c&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__